export default "__VITE_ASSET__102afe06__"